import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';
import { Trap } from 'src/domains/sportsbook/webview/components/trap/Trap';
import { Selection } from 'src/domains/sportsbook/webview/components/Selection';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

export const RunnerCell = styled('div', { label: 'RunnerCell' })`
    align-items: center;
    align-self: stretch;
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 auto;
    gap: 12px;
    justify-content: start;
    overflow: hidden;
    padding: 8px 12px;
`;

export const TrapCellRaceBox = styled(Trap, { label: 'TrapCellRaceBox' })`
    flex: 0 0 32px;
    height: 32px;
    padding: 4px;
`;

export const RacerName = withConfig(theme => styled('div', { label: 'RacerName' })`
    flex: 1 1 auto;
    font-size: ${theme.star.fontSize.small};
    color: ${theme.star.raceSummary.txtColor};
    justify-content: center;
    line-height: 1.3334;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
`);

interface SelectionWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

const setSelectionWrapper = (variant: DefaultComponentVariantType | null): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            margin: 4px;
            width: 64px;
            height: 40px;
        `;
    }
    return css``;
};

export const SelectionWrapper = styled(Selection, { label: 'SelectionWrapper' })<SelectionWrapperPropsType>`
    align-self: stretch;
    ${({ variant }): SerializedStyles => setSelectionWrapper(variant)}
`;
